import { getCookie, setCookie, updateCookie, text_truncate, getBrowserType, installInpObserver, getTrackingNonce, waitForFreshNonce, installTapMoveGuard, shouldIgnoreActivation, normalizeCodePlaceholder } from '../core/utils.js';

var code = '',
    ccode = '',
    leads_referrer = document.referrer;

export function tourButton() {

  // Prevent double-binding if this function is called multiple times.
  if (window.__jurnalTourButtonBound) return;
  window.__jurnalTourButtonBound = true;

  installInpObserver();
  installTapMoveGuard();

  // Prefer the server-baked URL (window.mlatConfig.ajaxUrl) over deriving it from
  // <link rel="https://api.w.org/">: on multilingual sites that link can come back
  // locale-prefixed (e.g. /en/wp-json/), and admin-ajax.php is never under that prefix.
  const wpApiLink = document.querySelector('link[rel="https://api.w.org/"]');
  const wpJsonBase = (wpApiLink && wpApiLink.href)
    ? wpApiLink.href.replace(/\/?$/, '/')
    : (window.location.origin + '/wp-json/');
  const wpSiteBase = wpJsonBase.replace(/wp-json\/?$/, '');
  const wpAjaxURL  = (window.mlatConfig && window.mlatConfig.ajaxUrl)
    || (wpSiteBase.replace(/\/?$/, '/') + 'wp-admin/admin-ajax.php');

  const setDisplayImportant = (el, value) => {
    try { el.style.setProperty('display', value, 'important'); } catch (e) { el.style.display = value; }
  };

  const showLoading = () => {
    if (typeof window.__jurnalShowLoading === 'function') { window.__jurnalShowLoading(); return; }
    document.querySelectorAll('.has-loading').forEach(el => setDisplayImportant(el, 'flex'));
  };

  const hideLoading = () => {
    if (typeof window.__jurnalHideLoading === 'function') { window.__jurnalHideLoading(); return; }
    document.querySelectorAll('.has-loading').forEach(el => setDisplayImportant(el, 'none'));
  };

  const browserType = getBrowserType();

  const isMobileUA = (() => {
    const ua = (navigator.userAgent || '').toLowerCase();
    return ua.includes('ipad') || ua.includes('iphone') || ua.includes('ipod') || ua.includes('android') || ua.includes('mobile');
  })();
  const deviceType = isMobileUA ? 'Mobile' : 'Desktop';

  const makeClickShort = () => {
    const d = new Date();
    const DD = String(d.getDate()).padStart(2, '0');
    const MM = String(d.getMonth() + 1).padStart(2, '0');
    const YY = String(d.getFullYear()).slice(2);
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds());
    const ms = String(d.getMilliseconds());
    return DD + MM + YY + hh + mm + ss + ms;
  };

  const postTourToDbAjax = async (payload) => {
    // Tap cepat setelah landing bisa mendahului fetch nonce baru → nonce HTML yang
    // (dari edge cache) mungkin sudah expired → 403. Tunggu sebentar (maks 1.5s).
    await waitForFreshNonce(1500);
    payload.nonce = getTrackingNonce();
    if (window.__jurnalWabaDebug) console.log('[mlat tour] POST →', wpAjaxURL + '?action=mlat_product_tour_store');
    const res = await fetch(wpAjaxURL + '?action=mlat_product_tour_store', {
      method: 'POST',
      // text/plain: CORS-safelisted (tidak pernah preflight); PHP baca php://input mentah.
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      keepalive: true
    });
    // Body dibaca juga untuk non-2xx: 403/500 dari PHP membawa `gsheets_sent`.
    const json = await res.text().catch(() => '').then(text => {
      try { return JSON.parse(text); } catch {
        const m = text.match(/(\{[\s\S]*\})/);
        if (m) try { return JSON.parse(m[1]); } catch {}
        if (window.__jurnalWabaDebug) console.warn('[mlat tour] non-JSON response body:', text.substring(0, 300));
        return null;
      }
    });
    if (window.__jurnalWabaDebug) console.log('[mlat tour] response (HTTP ' + res.status + '):', json);
    if (json === null && res.status === 200) {
      if (window.__jurnalWabaDebug) console.warn('[mlat tour] HTTP 200 but unparseable body — assuming DB OK, skipping GSheets');
      return { success: true };
    }
    if (!json || json.success !== true) {
      const msg = json && json.data && json.data.message ? json.data.message : ('admin-ajax HTTP ' + res.status);
      const err = new Error(msg);
      // Hanya percaya flag eksplisit dari PHP. Body non-JSON + non-200 (mis. 502/504
      // dari CDN) belum tentu sudah dikirim server → biarkan JS fallback jalan.
      err.gsheets_sent = !!(json && json.data && json.data.gsheets_sent);
      throw err;
    }
    return json;
  };

  const postTourToGSheets = (payload, gsheetsURL) => {
    const fd = new FormData();
    fd.append('Short', payload.short || '');
    fd.append('GCLID', payload.gclid || '');
    fd.append('Journey', payload.journey || '');
    fd.append('UTM Term', payload.utm_term || '');
    fd.append('Matchtype', payload.matchtype || '');
    fd.append('Device', payload.device || '');
    fd.append('Button Label & Button ID', payload.button_label_id || '');
    fd.append('Button Journey', payload.button_label_id || '');
    fd.append('GAID', payload.gaid || '');
    fd.append('utm_source', payload.utm_source || '');
    fd.append('utm_medium', payload.utm_medium || '');
    fd.append('utm_campaign', payload.utm_campaign || '');
    fd.append('Banner ID', payload.banner_id || '');
    fd.append('Waba Medium', payload.waba_medium || '');
    fd.append('Browser', payload.browser || '');
    fd.append('Domain', window.location.host || '');
    fd.append('GCLID Journey', payload.gclid_journey || '');
    fd.append('Referrer', payload.referrer || '');
    fd.append('Query Search Term', payload.query_search_term || '');
    fd.append('Visitor ID', payload.visitor_id || '');
    return fetch(gsheetsURL, { method: 'POST', body: fd, keepalive: true }).catch(() => {});
  };

  const getLinkFromEvent = (e) => {
    const rawTarget = e && e.target;
    const target = (rawTarget && rawTarget.nodeType === 3) ? rawTarget.parentElement : rawTarget;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('a');
  };

  let _lastHandledTs = 0;
  let _lastHandledEl = null;

  const clickHandler = (e) => {
    if (!e) return;
    if (e.__jurnalTourHandled) return;

    const link = getLinkFromEvent(e);
    if (!link) return;

    const href = link.href || '';
    const _mlatTourUrls = (window.mlatConfig && window.mlatConfig.productTour && window.mlatConfig.productTour.tourUrls)
      || ['jurnal.id/id/product-tour', 'jurnal.id/en/product-tour'];
    if (!_mlatTourUrls.some(u => href.includes(u))) return;

    // Abaikan klik kanan/tengah, pointer sekunder, dan ekor scroll/drag.
    if (shouldIgnoreActivation(e)) return;

    if (window.__jurnalWabaDebug) {
      console.log('[mlat tour] button detected:', {
        id: link.id || '(none)',
        classes: link.className,
        href: href.substring(0, 80),
        isTrusted: e && e.isTrusted,
      });
    }

    // Block synthetic events.
    try {
      if (typeof e.isTrusted === 'boolean' && e.isTrusted === false) {
        // Allow synthetic clicks when test/automation bypass flag is set.
        // Usage from Selenium/BrowserStack:
        //   driver.execute_script("window.__jurnalWabaAllowUntrusted = true;")
        if (window.__jurnalWabaAllowUntrusted === true) {
          // fall through — treat as trusted
        } else {
          try { e.__jurnalTourHandled = true; } catch (_) {}
          try { e.preventDefault(); } catch (_) {}
          try { if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); } catch (_) {}
          try { if (typeof e.stopPropagation === 'function') e.stopPropagation(); } catch (_) {}
          try { showLoading(); } catch (_) {}
          return;
        }
      }
    } catch (_) {}

    const now = (window.performance && typeof window.performance.now === 'function')
      ? window.performance.now()
      : Date.now();

    if (_lastHandledEl === link && (now - _lastHandledTs) < 900) {
      try { e.__jurnalTourHandled = true; } catch (_) {}
      try { e.preventDefault(); } catch (_) {}
      try { if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); } catch (_) {}
      try { if (typeof e.stopPropagation === 'function') e.stopPropagation(); } catch (_) {}
      try { showLoading(); } catch (_) {}
      return;
    }
    _lastHandledEl = link;
    _lastHandledTs = now;

    e.__jurnalTourHandled = true;
    try { e.preventDefault(); } catch (_) {}
    try { if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); } catch (_) {}
    try { if (typeof e.stopPropagation === 'function') e.stopPropagation(); } catch (_) {}

    showLoading();

    // Diisi di dalam try di bawah; tetap resolved kalau build payload gagal,
    // supaya navigasi tidak pernah tertahan.
    let trackPromise = Promise.resolve();
    const TOUR_TRACK_MAX_WAIT_MS = 3000;

    // ── Build payload & fire tracking BEFORE navigation ──────────────────
    // Product tour navigates the SAME tab (window.location.href).
    // If we defer tracking to scheduleIdle, the page may unload before
    // the callback fires → data never sent.
    // With keepalive:true the fetch survives page unload, but only if it's
    // actually started. So we build + fire it synchronously, then navigate.
    try {
      const url = new URL(window.location.href);
      const sp = url.searchParams;
      const cookieCache = new Map();
      const gc = (key) => {
        if (cookieCache.has(key)) return cookieCache.get(key);
        const val = getCookie(key) || '';
        cookieCache.set(key, val);
        return val;
      };
      const click_sh = makeClickShort();
      const gclid = sp.get('gclid') || gc('gclid');
      const msclkid = sp.get('msclkid') || gc('msclkid');
      const umedium = sp.get('utm_medium') || gc('utm_medium');
      const ucampaign = sp.get('utm_campaign') || gc('utm_campaign');
      const usource = sp.get('utm_source') || gc('utm_source');
      const utm_term = sp.get('utm_term') || gc('utm_term');
      const matchtype = sp.get('matchtype') || gc('matchtype');
      const banner_journey = gc('banner_journey');
      const cta_journey = gc('cta_journey');
      const cta_last_click = gc('cta_last_click');
      const medium_code = gc('waba_code');
      const query_keyword = sp.get('query') || gc('query_keyword') || 'null';

      let label = '';
      if (link.classList.contains('ic-wa')) {
        label = 'ID: ' + (link.id || '') + ', Label: Sticky WABA';
      } else if (link.classList.contains('top-banner-sticky') || link.classList.contains('top-banner-bot')) {
        label = 'ID: ' + (link.id || '') + ', Label: Sticky Banner';
      } else if (link.id) {
        label = 'ID: ' + link.id + ', Label: ' + (link.innerText || '');
      } else {
        label = 'ID: , Label: ' + (link.innerText || '');
      }

      let cta_journey_temp = '';
      if (cta_journey) {
        if (cta_last_click) {
          cta_journey_temp = (cta_last_click !== (link.id || '')) ? (cta_journey + '|' + label) : cta_journey;
        } else {
          cta_journey_temp = label;
        }
      } else {
        cta_journey_temp = label;
      }

      if (cta_journey) {
        updateCookie('cta_journey', cta_journey_temp);
      } else {
        setCookie('cta_journey', cta_journey_temp, 31);
      }
      if (cta_last_click) {
        updateCookie('cta_last_click', link.id || '');
      } else {
        setCookie('cta_last_click', link.id || '', 31);
      }

      const modifiedCampaign = normalizeCodePlaceholder((window.mlatConfig && window.mlatConfig.productTour && window.mlatConfig.productTour.ticketFormat) || '[Req.J{{code}}]').replace('{{code}}', click_sh);
      const campaignInfo = {
        gclid: gclid || '',
        utm_source: usource || '',
        utm_medium: umedium || '',
        utm_campaign: modifiedCampaign
      };
      const cookiesCampaignInfo = encodeURIComponent(JSON.stringify(campaignInfo));
      if (gc('created_at')) {
        updateCookie('campaign_info', cookiesCampaignInfo);
        updateCookie('j_campaign_info', cookiesCampaignInfo);
      } else {
        setCookie('campaign_info', cookiesCampaignInfo, 31);
        setCookie('j_campaign_info', cookiesCampaignInfo, 31);
      }

      const payload = {
        nonce: getTrackingNonce(),
        short: click_sh,
        gclid: text_truncate(`${gclid}|${msclkid}`, 250, ''),
        journey: (gc('user_journey') ? text_truncate(gc('user_journey'), 250, '') : ''),
        utm_term: utm_term,
        matchtype: matchtype,
        device: deviceType,
        button_label_id: cta_journey_temp,
        gaid: (gc('gaid') ? gc('gaid') : (gc('_ga') ? gc('_ga').slice(6) : '')),
        utm_source: usource,
        utm_medium: umedium,
        utm_campaign: ucampaign,
        utm_content: (sp.get('utm_content') || gc('utm_content') || ''),
        campaign_id: (sp.get('campaign_id') || gc('campaign_id') || ''),
        banner_id: banner_journey || '',
        waba_medium: medium_code || '',
        browser: browserType,
        domain: window.location.host || '',
        gclid_journey: (gc('gclid_journey') || ''),
        referrer: (gc('lead_referrer') ? gc('lead_referrer') : (leads_referrer || '')),
        query_search_term: query_keyword,
        visitor_id: (gc('visitor_id') || '')
      };

      const scriptURL = (window.mlatConfig && window.mlatConfig.productTour && window.mlatConfig.productTour.gsheetsUrl)
        || 'https://script.google.com/macros/s/AKfycbwEUWxemSWdZVSN-Z3gWqw38zeBfqgr27Mo4ea8kTt0wAHxW1brTKDHE5tK1fXGN69-Lg/exec';

      // Fire tracking fetch NOW (keepalive:true ensures it survives page unload).
      if (window.__jurnalWabaDebug) {
        console.log('[mlat tour] payload to DB:', {
          short: payload.short,
          nonce: payload.nonce ? payload.nonce.substring(0, 6) + '…' : '⚠️ MISSING',
          button_label_id: payload.button_label_id,
          utm_source: payload.utm_source,
          utm_medium: payload.utm_medium,
          utm_campaign: payload.utm_campaign,
          utm_term: payload.utm_term,
          device: payload.device,
          visitor_id: payload.visitor_id,
          ajaxUrl: wpAjaxURL + '?action=mlat_product_tour_store',
        });
      }
      // DB dulu (DITUNGGU); GSheets HANYA kalau DB gagal dan server belum kirim
      // sendiri (gsheets_sent) — juga DITUNGGU. Tidak ada beacon paralel, jadi
      // satu klik = satu baris (tidak ada duplikat `short`). Navigasi di bawah
      // menunggu trackPromise, maksimal TOUR_TRACK_MAX_WAIT_MS.
      trackPromise = postTourToDbAjax(payload)
        .then(() => {
          if (window.__jurnalWabaDebug) console.log('[mlat tour] DB OK → navigating');
        })
        .catch((errAjax) => {
          if (errAjax && errAjax.gsheets_sent) {
            if (window.__jurnalWabaDebug) console.log('[mlat tour] GSheets already sent by server, skipping JS fallback');
            return;
          }
          console.error('[mlat] Tour DB post failed, fallback to GSheets:', errAjax && errAjax.message ? errAjax.message : errAjax);
          return postTourToGSheets(payload, scriptURL);
        });
    } catch (err) {
      // no-op — don't block navigation if tracking fails
    }

    // ── Navigate AFTER tracking is started ───────────────────────────────
    const $url = href;
    const navigateMobile = () => {
      if (browserType === 'Apple Safari (iOS)') {
        const newTab = window.open('about:blank', '_self');
        if (newTab) {
          setTimeout(() => { try { newTab.location.href = $url; } catch (_) {} }, 200);
        }
      } else {
        window.location.href = $url;
      }
      // Deep-links (app scheme / wa.me) open an external app without unloading
      // the page — the browser tab stays visible. Hide the loader so the user
      // isn't stuck looking at a spinner indefinitely.
      setTimeout(() => { try { hideLoading(); } catch (_) {} }, 2500);
    };
    let navigated = false;
    const navigateOnce = () => {
      if (navigated) return;
      navigated = true;
      navigateMobile();
    };
    trackPromise.then(navigateOnce, navigateOnce);
    setTimeout(() => {
      if (!navigated && window.__jurnalWabaDebug) console.warn('[mlat tour] tracking still pending after ' + TOUR_TRACK_MAX_WAIT_MS + 'ms → navigating anyway (keepalive fetch continues)');
      navigateOnce();
    }, TOUR_TRACK_MAX_WAIT_MS);

    setTimeout(hideLoading, 4000);
    return;
  };

  const bind = (target, type) => {
    try {
      target.addEventListener(type, clickHandler, { passive: false, capture: true });
    } catch (e) {}
  };

  // 'click' + 'pointerup': pointerup menangkap tap pertama setelah scroll di mobile
  // (click-nya ditelan browser). shouldIgnoreActivation() menyaring klik kanan & drag.
  ['click', 'pointerup'].forEach((type) => {
    bind(window, type);
    bind(document, type);
  });
}
